<form>
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="bx bx-book-open me-1 font-20 text-primary"></i>Payment
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3 mb-2">
            <div class="col-md-4">
                <label for="frequency" class="form-label">Frequency <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-server'></i></span>
                    <input type="text" class="form-control ps-1" id="date" [value]="frequency ??'no-data'" readonly />
                </div>
            </div>
            <div class="col-md-4">
                <label for="date" class="form-label">Start Date<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                            class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="date" [value]="fromDate" readonly />
                </div>
            </div>
            <div class="col-md-4">
                <label for="date" class="form-label">End Date<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                            class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="date" [value]="toDate" readonly />
                </div>
            </div>
            <div class="col-md-4">
                <label for="providentFund" class="form-label">Provident Fund</label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-wallet'></i></span>
                    <input type="text" class="form-control ps-1" id="date" [value]="providentFundName ?? 'no-data'"
                        readonly />
                </div>
            </div>
            <div class="col-md-4">
                <label for="basicSalary" class="form-label">Basic Salary<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-wallet'></i></span>
                    <input type="number" class="form-control ps-1" id="basicSalary" placeholder="Enter basic Salary "
                        [value]="basicSalary" autocomplete="off" readonly />
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="active" [(ngModel)]="active">
                    <label class="form-check-label" for="prime">Active</label>
                </div>
            </div>
            <!-- <div class="col-lg-auto ms-auto">
                <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
                    [ngClass]="{'no-event':inProgress?.value=='true'}">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{salaryForm.value.id?'Updating...':'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx bx-save"></i>{{salaryForm.value.id?'Save Changes':'Save'}}
                    </ng-container>
                </button>
            </div> -->
        </div>
    </div>
</form>
<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <form [formGroup]="PaymentParticularForm" *ngIf="PaymentParticulars.length > 0">
                            <table class="table" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light">
                                        <th scope="col" width="300">Particular</th>
                                        <th scope="col" width="300">Amount</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="paymentParticulars">
                                    <tr *ngFor="let payment of PaymentParticulars.controls; let i=index"
                                        [formGroupName]="i">
                                        <td class="col-lg-4 px-0">
                                            <input type="text" readonly class="form-control"
                                                formControlName="salaryParticularName"
                                                formControlName="salaryParticularName"
                                                placeholder="Enter particular name"
                                                [ngClass]="{'is-invalid': submittedParticular && payment.get('salaryParticularName')?.invalid}" />
                                            <div class="invalid-feedback"
                                                *ngIf="submittedParticular && payment.get('salaryParticularName')?.invalid">
                                                <span *ngIf="payment.get('salaryParticularName')?.errors?.required">
                                                    Please enter a valid particular.
                                                </span>
                                            </div>
                                        </td>
                                        <td class="col-lg-4">
                                            <input type="number" class="form-control" formControlName="value"
                                                placeholder="Amount" required
                                                [ngClass]="{'is-invalid': submittedParticular && payment.get('value')?.invalid}">
                                            <div class="invalid-feedback"
                                                *ngIf="submittedParticular && payment.get('value')?.invalid">
                                                <span *ngIf="payment.get('value')?.errors?.required">Please
                                                    enter a valid amount.</span>
                                                <span *ngIf="payment.get('value')?.errors?.min">Amount must be
                                                    greater than {{minAmount}}.</span>
                                            </div>
                                        </td>
                                    </tr>                               
                                </tbody>
                            </table>
                            <div class="d-flex justify-content-between align-items-center mt-3 px-3">
                                <strong class="text-center" style="font-size: 1rem;margin-left: 258px;">Total Amount</strong>:
                                <span class="font-weight-bold" style="font-size: 1.2rem;margin-right: 286px">{{ totalAmount }}</span>
                            </div>
                        </form>
                        <div class="modal-footer  mt-2">
                            <button type="submit" class="btn btn-secondary" #inProgress
                                [ngClass]="{'no-event': inProgress?.value == 'true'}" (click)="saveDue(inProgress)">
                                <ng-container *ngIf="inProgress?.value == 'true'">
                                    <span class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
                                    Saving Due...
                                </ng-container>
                                <ng-container *ngIf="inProgress?.value != 'true'">
                                    <i class='bx bx-credit-card size'></i>Save Due
                                </ng-container>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>